<template>
  <div>
    <div class="row">
      <div class="col-12">
        <b-card header="Current Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row" v-if="order.rel_order_progress.order_progress_status === 'Live'">
            <div :class="[!check_if_worker_to_assign ? 'col-12' : 'col-lg-6']">
              <button @click.prevent="assign_worker" class="btn orcaBtn sm_btn w-100 mb-3">New Single Assignment</button>
              <hr>
            </div>
            <div class="col-lg-6" v-if="check_if_worker_to_assign">
              <button @click.prevent="assign_all_workers" class="btn orcaBtn grey_bg sm_btn w-100 mb-3">Assign All Workers</button>
            </div>
          </div>
          <div class="row">
            <div class="col-12" style="min-height: 400px">
              <currentDatable :row-data="current_assignments" :loading-message="'Loading Current Assignments...'" :no-rows-message="'No Current Assignments Found'"
                              :columns="current_ass_columns" :type="'assignment'" :record-type="'assignment'" :heightStyle="heightStyle"
                              :paginationPageSize="15"></currentDatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card header="Historic Assignments" header-tag="h4" body-class="mb-3 record_card_body">
          <div class="row">
            <div class="col-12" style="min-height: 400px">
              <historicDatable :row-data="historic_assignments" :loading-message="'Loading Historic Assignments...'" :no-rows-message="'No Historic Assignments Found'"
                               :columns="historic_ass_columns" :type="'assignment'" :record-type="'assignment'" :heightStyle="heightStyle"
                               :paginationPageSize="15"></historicDatable>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import currentDatable from 'datatables/assignments_datatable';
import historicDatable from 'datatables/assignments_datatable';

export default {
  name: "order_assignments",
  props: ['order', 'current_assignments', 'historic_assignments'],
  components: {
    currentDatable,
    historicDatable
  },
  data() {
    return {
      heightStyle: 'height: 400px !important',

      current_ass_columns: [
        {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        // {headerName: 'Client Name', minWidth: 200, field: 'client.client_name'},
        {headerName: 'Order Ref', minWidth: 110, field: 'order_job.order_ref'},
        {headerName: 'Worker Sage Ref', minWidth: 150, field: 'worker.internal_finance_ref'},
        {headerName: 'Worker Name', minWidth: 150, valueGetter: this.worker_full_name_vg},
        {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Admin Rate', minWidth: 115, valueGetter: this.h_admin_rate_vg},
        {headerName: 'Start Date', minWidth: 115, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', minWidth: 115, valueGetter: this.h_end_date_vg},
        {headerName: 'Assigned By', minWidth: 150, valueGetter: this.assignedName},
        {headerName: 'Gang Leader', minWidth: 90, valueGetter: this.h_gang_leader_vg},
        {headerName: 'Part of Gang', minWidth: 95, valueGetter: this.h_part_of_gang_vg},
        {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ],
      historic_ass_columns: [
        {headerName: 'Assigned Date', minWidth: 150, valueGetter: this.h_assigned_date_vg},
        // {headerName: 'Client Name', minWidth: 200, field: 'client.client_name'},
        {headerName: 'Order Ref', minWidth: 110, field: 'order_job.order_ref'},
        {headerName: 'Worker Sage Ref', minWidth: 150, field: 'worker.internal_finance_ref'},
        {headerName: 'Worker Name', minWidth: 150, valueGetter: this.worker_full_name_vg},
        {headerName: 'Job Title', minWidth: 150, field: 'order_job.rel_order_position.job_title'},
        {headerName: 'Pay Rate', minWidth: 100, valueGetter: this.h_pay_rate_vg},
        {headerName: 'Admin Rate', minWidth: 115, valueGetter: this.h_admin_rate_vg},
        {headerName: 'Start Date', minWidth: 115, valueGetter: this.h_start_date_vg},
        {headerName: 'End Date', minWidth: 115, valueGetter: this.h_end_date_vg},
        {headerName: 'Assigned By', minWidth: 150, valueGetter: this.assignedName},
        {headerName: 'Gang Leader', minWidth: 90, valueGetter: this.h_gang_leader_vg},
        {headerName: 'Part of Gang', minWidth: 95, valueGetter: this.h_part_of_gang_vg},
        {headerName: 'Gang Lead By', minWidth: 135, valueGetter: this.h_gang_lead_by_vg},
      ],
      check_if_worker_to_assign: null
    }
  },
  beforeMount() {
    this.checkAssignAll();
  },
  methods: {
    /**
     * Return whether there are any non-assigned workers to this order
     * that are assigned to other orders for this company with the same job title
     */
    checkAssignAll() {
      axios.get(this.crmApiPath + 'order/job/check_for_workers_to_all_assign/' + this.order.order.company_id + '/' + this.order.id)
           .then(res => this.check_if_worker_to_assign = res.data > 0)
    },
    /**
     * Full name for the user who made an assignment for datatable cells
     *
     * @param params
     * @returns {string}
     */
    assignedName(params) {
      return params.data.assigned_by.first_name + ' ' + params.data.assigned_by.surname;
    },
    /**
     * New assignment button clicked
     * Take user to order assignment vue template
     */
    assign_worker() {
      this.$store.commit('SET_ORDER_ASSIGNMENT', {
        company_id: this.order.order.company_id,
        order_job_id: this.order.id,
      })
      this.$nextTick(() => {
        this.$router.push('/orders/assignment');
        this.$tabs.refresh('/orders/assignment', true)
      });
    },
    /**
     * Assign all workers to order button
     * Take user to the all assign to order vue template
     */
    assign_all_workers() {
      this.$store.commit('SET_ORDER_ASSIGN_ALL', {
        company_id: this.order.order.company_id,
        order_job_id: this.order.id,
        order_job: this.order,
      })
      this.$nextTick(() => {
        this.$router.push('/orders/assign_all');
        this.$tabs.refresh('/orders/assign_all', true)
      });
    },
    /*
     * Value Getters for datatable headers
     */
    h_assigned_date_vg(params) {
      // return formatted date when an assignment was made
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    worker_full_name_vg(params) {
      // return Worker full name from returned data for datatable cells
      return params.data.worker.person.first_name + ' ' + params.data.worker.person.surname;
    },
    h_pay_rate_vg(params) {
      // return formatted pay rate amount (currency format)
      return this.$options.filters.currency(params.data.position_rate.pay_amount);
    },
    h_admin_rate_vg(params) {
      // if the admin rate type is 'currency type' format fee amount as currency
      if (params.data.position_rate.admin_fee_type === '£ (Pound)') {
        return this.$options.filters.currency(params.data.position_rate.admin_fee_amount);
      }
      // else if the admin rate type is 'percentage type' format fee amount as percentage
      else if (params.data.position_rate.admin_fee_type === '% (Percentage)') {
        return this.$options.filters.percentage(params.data.position_rate.admin_fee_amount);
      }
    },
    h_start_date_vg(params) {
      // return formatted date for the assignment start date
      return this.$options.filters.formatDate(params.data.start_date);
    },
    h_end_date_vg(params) {
      // return formatted date for the assignment end date
      return this.$options.filters.formatDate(params.data.end_date);
    },
    h_gang_leader_vg(params) {
      // return boolean value formatted as Yes/No for whether the worker is a gang leader on this assignment
      return params.data.is_gang_leader ? 'Yes' : 'No';
    },
    h_part_of_gang_vg(params) {
      // return boolean value formatted as Yes/No for whether the worker is part of a gang on this assignment
      return params.data.gang_leader !== null ? 'Yes' : 'No';
    },
    h_gang_lead_by_vg(params) {
      // return the full name of the gang leader if the worker is part of a gang on this assignment
      return params.data.gang_leader !== null ? params.data.gang_leader.full_name : '';
    },
  }
}
</script>

<style scoped>

</style>
